import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { fr } from './locales/fr';
import { en } from './locales/en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        translation: fr
      },
      en: {
        translation: en
      }
    },
    fallbackLng: 'fr',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false
    }
  });

// Force la synchronisation initiale de la langue avec localStorage
const savedLanguage = localStorage.getItem('i18nextLng');
if (savedLanguage) {
  i18n.changeLanguage(savedLanguage);
} else {
  const browserLang = navigator.language.split('-')[0];
  const defaultLang = ['fr', 'en'].includes(browserLang) ? browserLang : 'fr';
  i18n.changeLanguage(defaultLang);
  localStorage.setItem('i18nextLng', defaultLang);
}

export default i18n;